export const GET_PUBLIC_VEHICLES = 'GET_PUBLIC_VEHICLES';
export const GET_PUBLIC_VEHICLES_SUCCESS = 'GET_PUBLIC_VEHICLES_SUCCESS';
export const GET_PUBLIC_VEHICLES_ERROR = 'GET_VEHICLES_ERROR';

export const SET_PUBLIC_VEHICLES_FILTERS = 'SET_PUBLIC_VEHICLES_FILTERS';

export const POST_CONTACT_FORM = 'POST_CONTACT_FORM';
export const POST_CONTACT_FORM_SUCCESS = 'POST_CONTACT_FORM_SUCCESS';
export const POST_CONTACT_FORM_ERROR = 'POST_CONTACT_FORM_ERROR';
